import { useUserStore } from '@/stores/UserStore';

export const tokenFunc = async () => {
    const userStore = useUserStore();
    const response = await userStore.getToken;
    return `Bearer ${response}`;
}

//Bu servis token kontrolü için yapılmıştır yapılacak api isteklerine gönderilecek token buradan alınacaktır.
// Geliştirmeler için; erdemb@iposmobil.com.tr